import { search } from './search';

export function filter(data, callback) {
  const results = [];
  for (let i = 0; i < data.length; i += 1) {
    if (callback(data[i])) {
      results.push(data[i]);
    }
  }
  return results;
}

export function makePossible(data, modes, resultCount) {
  let possible = [];
  for (let i = 0; i < modes.length && possible.length < resultCount; i += 1) {
    const passed = filter(data,
      result => parseInt(result.lngCategoryId, 10) === modes[i]);
    possible = possible.concat(passed);
  }
  return possible;
}

export function ensureLength(reduced, original, resultCount) {
  if (reduced.length < resultCount) {
    for (let i = 0; i < original.length && reduced.length < resultCount; i += 1) {
      if (reduced.indexOf(original[i]) < 0) {
        reduced.push(original[i]);
      }
    }
  }
  return reduced;
}

export function sortedKeys(obj) {
  const keys = [];
  Object.keys(obj).forEach((key) => {
    keys.push(parseInt(key, 10));
  });
  return keys.sort((a, b) => obj[b] - obj[a]);
}

export function modes(data, attr) {
  if (data.length === 0) {return [];}
  const countedModes = {};
  for (let i = 0; i < data.length; i += 1) {
    const val = parseInt(data[i][attr], 10);
    if (countedModes[val]) {
      countedModes[val] += 1;
    } else if (val > 0) {
      countedModes[val] = 1;
    }
  }

  return sortedKeys(countedModes);
}

export function maxBy(data, attr) {
  let min = data[0];
  for (let i = 0; i < data.length; i += 1) {
    if (data[i][attr] > min[attr]) {
      min = data[i];
    }
  }
  return min;
}

export function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos);
}

export function bestMatch(args, callback) {
  const {
    resultCount,
    rawResults,
  } = args;

  // Overfetch data so that duplcate and null values can be rejected
  const searchArgs = { ...args };
  searchArgs.overFetchCount = searchArgs.resultCount * 4;

  search(searchArgs, (jsonData) => {
    const totalResults = jsonData.length;

    // Remove null and duplicate values
    const dedupData = removeDuplicates(jsonData, 'strProductName');
    const json = filter(dedupData, result => result != null);

    if (rawResults) {
      // Don't change the results. Just return
      callback(json.slice(0, resultCount), totalResults);
      return;
    }

    // Calculate the best matches based on the most frequent categories
    // (modes are a count of the number of times each category shows up.)
    const categoryModes = modes(json, 'lngCategoryId');
    const subCategoryModes = modes(json, 'lngSubCategoryId');
    let possible = makePossible(json, categoryModes, resultCount);

    if (possible.length > resultCount) {
      const reduced = filter(possible, result => result.lngSubCategoryId === `${subCategoryModes[0]}`);
      ensureLength(reduced, possible, resultCount);
    }

    // Include products with no category if they are on sale and have a reasonable ranking
    const noCategories = filter(json, (result) => {
      if (!result) {return false;}
      return result.lngCategoryId === '0' &&
        result.dblProductOnSalePercent > 10 &&
        result.intSearchResultScore >= (json[0].intSearchResultScore - 100);
    });
    possible = possible.concat(noCategories);

    ensureLength(possible, json, resultCount);

    // Sort based on sale percent
    possible.sort((a, b) => a.dblProductOnSalePercent < b.dblProductOnSalePercent);

    callback(possible.slice(0, resultCount), totalResults);
  });
}
